// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"c0f7f79f","195":"c0f7f79f","474":"af8fb1b2","537":"c0f7f79f","731":"abf52af5"}[chunkId] + ".chunk.css";
};